export const NAME = 'CasovaUdalost';
export const SNIMANIE_CASU = 'SnimaniCasu';
export const SNIMANIE_CASU_CRUMB_LABEL_KEY = 'edtCUbarcode';
export const CRUMB_LABEL_KEY = 'edtCU';
export { DMS_MODULE } from '../constants';

export const TIME_TABLE = 'EscDnes';

export const depTableNames = [TIME_TABLE];
